// extracted by mini-css-extract-plugin
module.exports = {"icon":"i_Qr","easy":"i_Qs","challenging":"i_Qt","hard":"i_Qu","found":"i_Qv","label":"i_Qw"};